import { FC, useMemo, useState } from "react";
import { FilterColumnItem } from "@vviinn/user-managment-client-ts";
import { CampaignFilterSortingEnum } from "@vviinn/user-managment-client-ts/dist/models/Campaign";

import { NamedRow } from "../../../../../components/GeneralUI/NamedRow/NamedRow";
import { FiltersSlideOver } from "./FiltersSlideOver";
import { useAppSelector } from "../../../../../store";

import { initFilterConfig } from "./helpers/initFilterConfig";
import { UpdateCampaignBody } from "../../../types";

export const FiltersRow: FC<
  UpdateCampaignBody & {
    initFiltersSorting?: CampaignFilterSortingEnum;
    enabledFilterColumns: FilterColumnItem[];
    enableCustomFilters: boolean;
  }
> = ({
  updateCampaignBody,
  initFiltersSorting,
  enabledFilterColumns,
  enableCustomFilters,
}) => {
  const [filtersModalOpen, setFiltersModalOpen] = useState(false);

  const defaultFilters = useAppSelector((state) => state.campaigns.filters);

  const { customFieldsTitles, loading } = useAppSelector((state) => state.site);

  const availableCampaignFilters = useMemo(
    () =>
      enableCustomFilters
        ? loading
          ? undefined
          : [...defaultFilters, ...customFieldsTitles]
        : defaultFilters,
    [enableCustomFilters, loading, defaultFilters, customFieldsTitles],
  );

  const initFilterData = useMemo(
    () =>
      availableCampaignFilters
        ? initFilterConfig(
            availableCampaignFilters,
            enabledFilterColumns,
            initFiltersSorting,
          )
        : undefined,
    [availableCampaignFilters, enabledFilterColumns, initFiltersSorting],
  );

  return (
    <>
      <NamedRow
        title="Filters"
        editPermissions="campaign:basic_config:update"
        content={initFilterData?.activeFiltersAmount}
        onClick={() => !loading && setFiltersModalOpen(true)}
        fixedHeight={true}
        isLoading={loading}
      />
      {initFilterData && (
        <FiltersSlideOver
          open={filtersModalOpen}
          onClose={() => setFiltersModalOpen(false)}
          updateCampaignBody={updateCampaignBody}
          initFiltersSorting={initFiltersSorting}
          {...initFilterData}
        />
      )}
    </>
  );
};
